import classNames from 'clsx';
import React from 'react';

import dropDownStyles from '../PanelDropDown/PanelDropDown.scss';

import styles from './PanelItem.scss';

export interface Props {
  panelId: number;
  togglePanel?: (panelId: number) => void;
  hasInfo?: boolean;
  isOpened?: boolean;
  selectedPanelId?: number;
  panelClassName?: string;
}

const PanelItem: React.FC<Props> = (props) => {
  const { panelId, togglePanel, isOpened, hasInfo, selectedPanelId, panelClassName } = props;

  return (
    <div
      className={classNames(
        styles.panel,
        dropDownStyles.panel,
        panelClassName,
        { [styles.hasInfo]: hasInfo },
        { [styles.opened]: isOpened && selectedPanelId === panelId }
      )}
      onClick={() => togglePanel && togglePanel(panelId)}
    >
      {props.children}
    </div>
  );
};

export default PanelItem;
